export function canonicalLessonId(week, lesson) {
  const w = Number(week);
  const l = Number(lesson);
  if (!Number.isFinite(w) || !Number.isFinite(l)) return "";
  return `W${w}L${l}`;
}

export function studentLessonPathFor(studentId, week, lesson) {
  const sid = String(studentId || "").trim();
  if (!sid) return "";

  const w = Number(week) || 1;
  const l = Number(lesson) || 1;
  return `/student/dashboard/${sid}/lessons/week/${w}/lesson/${l}`;
}

export function lessonPathFor(basePrefix, week, lesson) {
  const prefix = String(basePrefix || "").trim().replace(/\/+$/, "");
  if (!prefix) return "";
  const w = Number(week) || 1;
  const l = Number(lesson) || 1;
  if (prefix.includes("/student/dashboard/") && !prefix.includes("/lessons")) {
    return `${prefix}/lessons/week/${w}/lesson/${l}`;
  }
  return `${prefix}/week/${w}/lesson/${l}`;
}
